export default __webpack_public_path__ + "static/media/Bg_free_logo.56a410e9.png";